import React from "react";
import { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineDriveFolderUpload } from "react-icons/md";
import { ListMedicine } from "./listofMedicine";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string, mixed } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  name: string().when("file", {
    is: (file) => !file,
    then: (schema) => schema.required("Medicine name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  type: string().when("file", {
    is: (file) => !file,
    then: (schema) => schema.required("Medicine type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  file: mixed().nullable(), // explicitly declare file field
});

export function AddMedicineMenu() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [label, setLabel] = useState("File upload.xlsx ");
  const [file, setFile] = useState(null);

  // function handleLabel(e) {
  //   setLabel(e.target.files[0]?.name || "File upload.pdf");
  // }

  const formik = useFormik({
    initialValues: {
      name: "",
      type: "",
      file: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();

        if (file) {
          // Bulk upload mode
          formData.append("file", file);
          const response = await axiosInstance.post(
            "/admin/master-medicine/",
            formData
          );

          if (response.data.status === "success") {
            toast.success("Bulk upload successful!");
            setTimeout(() => navigate("/medicine"), 1500);
          } else {
            toast.error(response.data.message || "Bulk upload failed.");
          }
        } else {
          // Single entry mode
          formData.append("name", values.name.trim());
          formData.append("type", values.type);

          const response = await axiosInstance.post(
            "/admin/master-medicine/",
            formData
          );

          if (response.data.status === "success") {
            toast.success("Medicine added successfully!");
            setTimeout(() => navigate("/medicine"), 1500);
          } else {
            toast.error(response.data.message || "Failed to add medicine.");
          }
        }
      } catch (err) {
        console.error("❌ Error:", err);
        // 👇 Handle server validation error here
        if (
          err.response &&
          err.response.status === 400 &&
          err.response.data?.errors?.name
        ) {
          formik.setFieldError("name", err.response.data.errors.name[0]);
        } else {
          toast.error("Something went wrong. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    },
  });

  const handleLabel = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setLabel(uploadedFile.name);
      formik.setFieldValue("file", uploadedFile);
    } else {
      setFile(null);
      setLabel("File upload.csv");
      formik.setFieldValue("file", null);
    }
  };

  const handleCancel = () => {
    formik.resetForm();
    setFile(null);
    setLabel("File upload.csv");
    navigate("/medicine");
  };

  const isBulkUpload = !!file;

  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <IoIosArrowBack
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/medicine")}
        />
        <div className="add-title">Add Medicine</div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Medicine Type
              </label>
              <div>
                <select
                  className="admin-type"
                  name="type"
                  value={formik.values.type}
                  onChange={formik.handleChange}
                  disabled={isBulkUpload}
                >
                  <option value="">Select Medicine Type</option>
                  <option value="surgical">Surgical</option>
                  <option value="medicine">Medicine</option>
                </select>
                {formik.touched.type && formik.errors.type && (
                  <div className="text-danger">{formik.errors.type}</div>
                )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Medicine Name
              </label>
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter Medicine Name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  disabled={isBulkUpload}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="text-danger">{formik.errors.name}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* bulk upload */}
        <div className="addAdmin-subcontainer">
          <div className="add-title">Bulk Uplaod (Upload xlsx File)</div>
        </div>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="editWholesaler-field">
              <label>Bulk Upload</label>
              <label htmlFor="file" className="labelFile">
                {label}
                <span style={{ float: "right", fontSize: "18px" }}>
                  <MdOutlineDriveFolderUpload />
                </span>
              </label>
              <input
                type="file"
                id="file"
                className="inputFile"
                accept=".xlsx"
                onChange={handleLabel}
                disabled={formik.values.name || formik.values.type}
              />
            </div>
          </div>
        </div>

        {/* buttons */}
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
